/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var log = require('../../utils/logger')('splitio-producer:updater');

var TaskFactory = require('../task');

var SplitChangesUpdater = require('../updater/SplitChanges');
var MySegmentsUpdater = require('../updater/MySegments');

/**
 * Startup all the background jobs required for a Browser SDK instance.
 */
var FullBrowserProducer = function FullBrowserProducer(context) {
  var splitsUpdater = SplitChangesUpdater(context);
  var segmentsUpdater = MySegmentsUpdater(context);
  var settings = context.get(context.constants.SETTINGS);

  var splitsUpdaterTask = TaskFactory(splitsUpdater, settings.scheduler.featuresRefreshRate);
  var segmentsUpdaterTask = TaskFactory(segmentsUpdater, settings.scheduler.segmentsRefreshRate);

  return {
    start: function start() {
      log.info('Starting BROWSER producer');

      splitsUpdaterTask.start();
      segmentsUpdaterTask.start();
    },
    stop: function stop() {
      log.info('Stopping BROWSER producer');

      splitsUpdaterTask.stop();
      segmentsUpdaterTask.stop();
    }
  };
};

module.exports = FullBrowserProducer;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/producer/browser/Full.js
// module id = 693
// module chunks = 10